import { useState } from 'react';
import { InventoryPage, InventoryHeader, InventoryBody } from './InventoryComponents';
import {
  InventoryDeleteModal,
  InventoryUpdateModal,
  InventoryCompleteModal,
} from '../../design-system';
import { RoleGuard } from '../../routes';

export const Inventory = () => {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <RoleGuard roles={['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_VIEWER', 'YARD_MANAGER']}>
      <InventoryPage id={'inventory-page'} innerScroll>
        <InventoryHeader totalCount={totalCount} />
        <InventoryBody setTotalCount={setTotalCount} />
      </InventoryPage>
      <InventoryDeleteModal />
      <InventoryUpdateModal />
      <InventoryCompleteModal />
    </RoleGuard>
  );
};
